export default {
  data() {
    return {
      showHidden: false,
      tableData: [],
      filteredData: [],
      multipleSelectionIcon: "eye-off",
      multipleHidingAction: true,
      tableOptions: {
        currentPage: 1,
        perPage: 25,
        loading: true,
        page: 1,
        total: 0,
        isPaginated: true,
        isPaginationSimple: true,
        checkedRows: [],
        queryString: "",
        paginationPosition: "bottom",
        sortIcon: "arrow-up",
        sortIconSize: "is-small"
      }
    };
  },
  methods: {
    printAddress(address) {
      let string = "";
      if (address["street"]) string += address["street"];
      if (address["city area"]) {
        if (string != "") string += ", ";
        string += address["city area"];
      }
      if (address["city"]) {
        if (string != "") string += ", ";
        string += address["city"];
      }
      if (address["county"]) {
        if (string != "") string += ", ";
        string += address["county"];
      }
      if (address["postal code"]) {
        if (string != "") string += ", ";
        string += address["postal code"];
      }
      if (address["country"]) {
        if (string != "") string += ", ";
        string += address["country"];
      }
      return string;
    },
    multipleDelete(collection) {
      this.$buefy.dialog.confirm({
        title: this.$translate("attention"),
        message: this.$translate("delete_confirm_text"),
        cancelText: this.$translate("undo"),
        confirmText: this.$translate("delete"),
        onConfirm: () => {
          this.tableOptions.checkedRows.forEach(element => {
            this.deleteItem(element, collection);
          });
        }
      });
    },
    multipleHiding(collection) {
      if (this.multipleHidingAction) {
        this.tableOptions.checkedRows.forEach(element => {
          this.hideItem(element, collection);
        });
      } else {
        this.tableOptions.checkedRows.forEach(element => {
          this.unhideItem(element, collection);
        });
      }
      this.multipleSelectionIconManage(this.tableOptions.checkedRows);
      this.tableOptions.checkedRows = [];
      this.searchData();
    },
    multipleSelectionIconManage(checkedList) {
      let icon = "eye";
      this.multipleHidingAction = false;
      checkedList.forEach(element => {
        if (element.isActive) {
          icon = "eye-off";
          this.multipleHidingAction = true;
        }
      });
      this.multipleSelectionIcon = icon;
    },
    deleteItem(item, collection) {
      this.$db
        .collection(collection)
        .doc(item.id)
        .delete()
        .then();
      this.tableData = this.tableData.filter(el => el.id !== item.id);
      this.filteredData = this.filteredData.filter(el => el.id !== item.id);
    },
    hideItem(item, collection) {
      item.isActive = false;
      this.$db
        .collection(collection)
        .doc(item.id)
        .update({ isActive: false })
        .then(() => {
          item.isActive = false;
        });
    },
    unhideItem(item, collection) {
      item.isActive = true;
      this.$db
        .collection(collection)
        .doc(item.id)
        .update({ isActive: true })
        .then(() => {
          item.isActive = true;
        });
    },
    addFilter(list, filter) {
      let toAdd = true;
      list.forEach(element => {
        if (filter == undefined || element.name == filter) toAdd = false;
      });
      if (toAdd) list.push({ name: filter });
    },
    switchViewHidden(showHidden) {
      this.showHidden = showHidden;
      this.searchData();
    },
    searchData() {
      //console.log("Devi implementare searchData per questo componente!");
    },
    matchFilter(queryString = "", fieldsValue = []) {
      let regexp = new RegExp(`w*${queryString}w*`, `gmi`);
      let match = false;
      fieldsValue.forEach(fieldValue => {
        if (fieldValue && fieldValue.match(regexp)) match = true;
      });
      return match;
    },
    getAllInPromises(collection, selectAttribute, whereArray, whereAttribute) {
      let promises = [];
      let baseRequest = this.$db.collection(collection);
      for (let i = 0; i < whereArray.length; i += 10) {
        if (whereAttribute) {
          promises.push(
            baseRequest
              .where(
                selectAttribute,
                "in",
                whereArray
                  .slice(i, i + 10)
                  .map(element => element[whereAttribute])
              )
              .get()
          );
        } else {
          promises.push(
            baseRequest
              .where(selectAttribute, "in", whereArray.slice(i, i + 10))
              .get()
          );
        }
      }
      return promises;
    }
  }
};
